import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import { RetirePipeClassDialogComponent, RetirePipeClassDialogData } from 'src/app/search/retire-pipe-class-dialog/retire-pipe-class-dialog.component';
import { PipeClassViewModel } from 'src/app/shared/models/autogenerated-piping';

@Component({
  selector: 'app-retire-pipe-class-button',
  templateUrl: './retire-pipe-class-button.component.html',
  styleUrls: ['./retire-pipe-class-button.component.scss'],
  standalone: false,
})
export class RetirePipeClassButtonComponent {
  /** The pipe class this button acts upon. */
  @Input() pipeClass: PipeClassViewModel;

  /** Emitted when the retire operation completes successfully so the parent
   *  can refresh the search results immediately. */
  @Output() pipeClassRetired: EventEmitter<void> = new EventEmitter<void>();

  constructor(private readonly dialog: MatDialog) {}

  /**
   * Opens the retire confirmation dialog.
   * If the user confirms and the API succeeds, emits `pipeClassRetired` so the
   * parent search page can trigger a refresh.
   */
  openRetireDialog(): void {
    if (!this.pipeClass?.id) { return; }

    const dialogData: RetirePipeClassDialogData = {
      pipeClassId:   this.pipeClass.id,
      pipeClassName: this.pipeClass.name,
    };

    const dialogRef = this.dialog.open(RetirePipeClassDialogComponent, {
      width: '500px',
      disableClose: false,
      data: dialogData,
    });

    // After the dialog closes, check if the retire succeeded and notify the parent.
    dialogRef.afterClosed().pipe(first()).subscribe((retired: boolean) => {
      if (retired) {
        this.pipeClassRetired.emit();
      }
    });
  }
}
